// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Core from "@material-ui/core";
import * as FormInputHelper$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/components/generic/form/form-input/FormInputHelper.bs.js";
import * as FormInputWrapper$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/components/generic/form/form-input/FormInputWrapper.bs.js";
import * as MaterialUi_TextareaAutosize from "../../../../../node_modules/rescript-material-ui/src/MaterialUi_TextareaAutosize.bs.js";
import * as CrmGenericComponentAssetsManager from "../assets/CrmGenericComponentAssetsManager.bs.js";

CrmGenericComponentAssetsManager.importCss(undefined);

function FormTextArea(Props) {
  var input_props = Props.input_props;
  var textinput_props = Props.textinput_props;
  var rowsOpt = Props.rows;
  var rows = rowsOpt !== undefined ? rowsOpt : "5";
  var match = React.useState(function () {
        
      });
  var setWarning = match[1];
  return React.createElement(FormInputWrapper$Catalyst.make, {
              className: input_props.className,
              children: null,
              on_click: input_props.onClick
            }, React.createElement(Core.TextareaAutosize, {
                  className: "form-text-area-input",
                  onChange: (function ($$event) {
                      $$event.persist();
                      Curry._1(setWarning, (function (param) {
                              return Curry._1(input_props.warning, $$event);
                            }));
                      return Curry._1(input_props.onChange, $$event);
                    }),
                  placeholder: input_props.placeholder,
                  rows: MaterialUi_TextareaAutosize.Rows.string(rows),
                  value: MaterialUi_TextareaAutosize.Value.string(textinput_props.value)
                }), FormInputHelper$Catalyst.getWarningOrError(match[0], input_props.result, input_props.helper_text));
}

var make = FormTextArea;

export {
  make ,
  
}
/*  Not a pure module */
